import * as React from 'react'
import ArrowDown from '../icons/ui/ArrowDown'
import ArrowUp from '../icons/ui/ArrowUp'

interface IItemSelectorProps<T> {
  items?: T[]
  selectedIndex?: number
  onItemSelected?: (index: number, val: T) => void
}

interface IItemsSelectorState<T> {
  items: T[]
  selectedIndex: number
  scrollVisible: boolean
}

class ItemSelector<T> extends React.Component<IItemSelectorProps<T>, IItemsSelectorState<T>> {
  constructor(props: IItemSelectorProps<T>) {
    super(props)
    this.state = {
      items: props.items ? props.items : [],
      selectedIndex: props.selectedIndex ? props.selectedIndex : 0,
      scrollVisible: false
    }
  }

  public render() {
    const { items, selectedIndex, scrollVisible } = this.state
    return (
      <div className='w36'>
        <div
          className='col-12 flex flex-wrap justify-center items-center mb1 cursor--pointer'
          onClick={this.handleIncrement}
        >
          <ArrowUp className='icon--10x10 m-auto' />
        </div>
        <div className='relative'>
          <div
            className='ItemContainer col-12 bg-green font-white center py1 user-select-none cursor--pointer'
            onClick={this.handleValueClick}
          >
            {items.length > 0 ? items[selectedIndex] : ''}
          </div>
          {scrollVisible && (
            <div className='Scroll time-settings-counter z2'>
              {items.map((it, index) => (
                <div
                  key={`item-${index}`}
                  className='ScrollItem settings-counter-item font-grey'
                  onClick={this.handleItemClick(index)}
                >
                  {it}
                </div>
              ))}
            </div>
          )}
        </div>
        <div
          className='col-12 flex flex-wrap justify-center items-center mt1 cursor--pointer'
          onClick={this.handleDecrement}
        >
          <ArrowDown className='icon--10x10 m-auto' />
        </div>
      </div>
    )
  }

  private handleIncrement = () => {
    if (this.state.selectedIndex < this.state.items.length - 1) {
      const nextIndex = this.state.selectedIndex + 1
      this.setState({ selectedIndex: nextIndex })
      if (this.props.onItemSelected) {
        this.props.onItemSelected(nextIndex, this.state.items[nextIndex])
      }
    }
  }

  private handleDecrement = () => {
    if (this.state.selectedIndex > 0) {
      const nextIndex = this.state.selectedIndex - 1
      this.setState({ selectedIndex: nextIndex })
      if (this.props.onItemSelected) {
        this.props.onItemSelected(nextIndex, this.state.items[nextIndex])
      }
    }
  }

  private handleValueClick = () => {
    if (this.state.items.length) {
      this.setState({ scrollVisible: true })
    }
  }

  private handleItemClick = (index: number) => () => {
    this.setState({ selectedIndex: index, scrollVisible: false })
    if (this.props.onItemSelected) {
      this.props.onItemSelected(index, this.state.items[index])
    }
  }
}

class StringItemSelector extends ItemSelector<string> {}

export { ItemSelector, StringItemSelector }



// WEBPACK FOOTER //
// ./src/components/ui/ItemSelector.tsx